import React from 'react';
import './courseHighLightDiv.css'; // Make sure this file exists
import { Link } from 'react-scroll';
import { useDispatch } from 'react-redux';
import { setActiveContentTabIndex } from '../../../C2wStore/actions';

function C2wCourseHighLightDiv({ obj, index, isSelected, onClick }) {
  const dispatch = useDispatch()
  return (
      <Link
        className={`C2wCourseHighLightDiv_ctn ${isSelected ? 'selectedHighLightBar' : ''}`}
        onClick={() => {
          onClick?.()
          dispatch(setActiveContentTabIndex(index))
        }}
        to={`section${index}`}
        smooth={true} 
        duration={500}
        offset={-139}
        containerId='C2wCourseDetailsContainer'
      >
        {obj}
      </Link>
  );
} 
 
export default C2wCourseHighLightDiv;
